import './footer.scss';

$(document).ready(function(){

  // footer button scroll to top
  $(".to-up").click(function(){
    $("html, body").animate({ scrollTop: 0 }, 800);
  });

});